import store from '@/store'

export default function(_this) {
  return {
    /**
     * Create widget for data grid
     * @param {Object} data - data colection that contains options
     * @param {Object} ref - firebase reference
     */
    async createNew(data, ref) {
      if (!ref) ref = _this.getRef()

      const widget = {
        gsOptions: data.gsOptions,
        layout: 'b-card',
        tab: data.tab,
        subtab: data.subtab || null,
        overflow: 'height: auto',
        type: 'DataGrid',
        props: {
          gridId: data.source,
        },
      }

      const widgetKey = await new Promise(resolve => {
        _this.widgets.create(
          widget,
          key => {
            store.commit('addedWidgetKey', key);
            resolve(key)
          },
          ref
        )
      })

      const gridOptions = {
        title: data.title,
        storageType: data.storageType,
        source: data.source,
        displayColumn: 'name',
      }

      if (data.filterVisible) gridOptions.filterVisible = data.filterVisible
      if (data.calendarId) gridOptions.calendarId = data.calendarId

      await new Promise(resolve => {
        ref
          .child(`widgetsData/dataGrid/${data.source}`)
          .set(gridOptions, err => {
            if (err) console.error(err)
            resolve()
          })
      })

      await this.initRowEditor(data.source, ref)

      await new Promise(resolve => {
        ref
          .child(`widgets/${widgetKey}/dependency`)
          .set(`dataGrid/${data.source}`, () => resolve())
      })

      return widgetKey
    },
    /**
     * Create widget for data grid
     * @param {Object} data - data colection that contains options
     */
    copy(data) {
      const widget = {
        gsOptions: {
          x: 0,
          y: 0,
          w: 24,
          h: 18,
        },
        layout: 'b-card',
        tab: data.tab,
        subtab: data.subtab || null,
        overflow: 'height: auto',
        type: 'DataGrid',
        props: {
          gridId: data.gridId,
        },
      }

      return new Promise(resolve => {
        _this.widgets.create(widget, () => resolve())
      })
    },
    /**
     * Init settings model for row editor
     * @param {string} gridId - DataGrid component id
     */
    domUniqueID(prefix) {
      var id = prefix + _.random(0, 999999)
      if ($('#' + id).length > 0) {
        return this.domUniqueID(prefix)
      }

      return id
    },
    initRowEditor(gridId, ref) {
      if (!ref) ref = _this.getRef()
      return new Promise(resolve => {
        const sectionId = this.domUniqueID('section_')
        const rowKey = this.domUniqueID(sectionId + '_row_')

        const rowEditorData = JSON.stringify({
          sections: [
            {
              name: sectionId,
              label: '',
              clientKey: sectionId,
              order: 0,
              rows: [
                {
                  name: rowKey,
                  label: '',
                  order: 0,
                  controls: [],
                },
              ],
              labelPosition: 'left',
              isDynamic: false,
              minInstance: 1,
              maxInstance: 0,
              instances: [],
            },
          ],
          layout: 'collapse',
        })

        ref
          .child(`widgetsData/dataGrid/${gridId}/rowEditorFieldsForm`)
          .set(rowEditorData, () => resolve())
      })
    },
    createEditRowComponent(gridId, rowKey, tab, gsOptions, subtab) {
      const widget = {
        template: `<DataGridEditRow gridId="${gridId}" rowKey="${rowKey}" />`,
        gsOptions,
        tab,
        subtab: subtab || null,
        layout: 'b-card',
      }

      return new Promise(resolve => {
        _this.widgets.create(widget, (key) => resolve(key))
      })
    },
  }
}
